import { IInfluencer } from "@/models";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})
export default class InfluencerCard extends Vue {
    @Prop({ type: Object, required: true })
    public influencer: IInfluencer;
}
